import React from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useLocation } from "react-router-dom";
import { getStripComponentFromStripData } from '../services/stripsService';
export default function StripContentSliderContainer(props) {
    var fields = props.fields, children = props.children;
    var pathname = useLocation().pathname;
    //useEffect(() => {
    //    window.scrollTo(0, 0);
    //}, [pathname]);
    return (React.createElement(Splide, { hasTrack: false, "aria-label": "My Favorite Images", options: {
            type: 'loop',
        }, className: "strip sky23-content-slider splide top-margin-half bottom-margin-half text-moss container-fluid" },
        React.createElement("div", { className: "row content-slider-wrapper" },
            React.createElement("div", { className: "col content-slider-col" },
                React.createElement(SplideTrack, null, fields && children && children.length > 0 && children.map(function (strip, j) {
                    return (React.createElement(SplideSlide, { key: j }, getStripComponentFromStripData(strip)));
                })))),
        React.createElement("div", { className: "splide__arrows" },
            React.createElement("button", { className: "splide__arrow splide__arrow--prev" }, "Prev"),
            React.createElement("button", { className: "splide__arrow splide__arrow--next" }, "Next"))));
}
